import { render, staticRenderFns } from "./StockableItemFixtures.vue?vue&type=template&id=6b5a2137&"
import script from "./StockableItemFixtures.vue?vue&type=script&lang=ts&"
export * from "./StockableItemFixtures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports